<div class="margin-bottom-lg">
	<mat-card-title class="h5">
		Child IDs
	</mat-card-title>
	<mat-divider> </mat-divider>

	<div class="margin-top-md">
		<mat-table [dataSource]="childIdTableDataSource" class="table-responsive mat-elevation-z1" matSort>
			<form [formGroup]="ssidEditingForm">
				<ng-container matColumnDef="EDIT">
					<mat-header-cell *matHeaderCellDef> </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div
							*ngIf="element.ID !== ssidEditingId && element.STUDENT_IDENTIFIER_TYPES.TYPE === 'SSID Number' && ssidFound">
							<button mat-icon-button color="primary" (click)="editSSID(element)" matTooltip="Edit">
								<mat-icon>edit</mat-icon>
							</button>
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'delete'" [color]="'warn'"
								[popoverMsg]="'Delete Confirmation'" [popoverConfirmText]="'Delete'"
								[popoverConfirmColor]="'warn'" [tooltip]="'Delete'" (onConfirm)="deleteSSID(element)">
							</confirm-popover>
						</div>
						<div *ngIf="element.ID === ssidEditingId && ssidFound">
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'check'" [color]="'primary'"
								[popoverMsg]="'Update SSID'" [popoverConfirmText]="'Confirm'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Update'" (onConfirm)="confirmEditSSID()"
								[disabled]="!ssidEditingForm.valid">
							</confirm-popover>

							<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
								[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'" [popoverCancelText]="'No'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Cancel'" (onConfirm)="cancelEditSSID()">
							</confirm-popover>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="STUDENT_IDENTIFIER_TYPES.TYPE">
					<mat-header-cell *matHeaderCellDef mat-sort-header> ID TYPE </mat-header-cell>
					<mat-cell *matCellDef="let element" class="row">
						<div *ngIf="element.ID !== ssidEditingId">
							{{element.STUDENT_IDENTIFIER_TYPES.TYPE}}
							<app-view-child-ssid-history-btn class="pull-right" [studentId]="studentId"
								*ngIf="element.STUDENT_IDENTIFIER_TYPES?.TYPE === 'SSID Number'"></app-view-child-ssid-history-btn>
						</div>
						<div *ngIf="element.ID === ssidEditingId" class="col">
							<div class="row">
								<mat-form-field class="mat-form-field-padding">
									<mat-label>
										ID Type
									</mat-label>
									<mat-select formControlName="idType" [disabled]="true">
										<mat-option *ngFor="let studentIdentifierType of studentIdentifierTypes"
											[value]="studentIdentifierType" [disabled]="true">
											{{studentIdentifierType.TYPE}}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="IDENTIFIER_VALUE">
					<mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
					<mat-cell *matCellDef="let element" class="row">
						<div *ngIf="element.ID !== ssidEditingId">
							{{element.IDENTIFIER_VALUE}}
						</div>
						<div *ngIf="element.ID === ssidEditingId">
							<input-ssid [form]="ssidEditingForm" [controlName]="'identifierValue'"
								[studentId]="studentId"></input-ssid>
						</div>
					</mat-cell>
				</ng-container>
			</form>

			<ng-container matColumnDef="ADD" disabled>
				<mat-header-cell *matHeaderCellDef>
					<div *ngIf="!addingSSID">
						<button mat-raised-button color="primary" (click)="addSSID()">New SSID</button>
					</div>
				</mat-header-cell>
			</ng-container>

			<form [formGroup]="ssidAddingForm">
				<ng-container matColumnDef="ADD_EDIT" disabled>
					<mat-header-cell *matHeaderCellDef>
						<div *ngIf="addingSSID">
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'add'" [color]="'primary'"
								[popoverMsg]="'Add new SSID'" [popoverConfirmText]="'Add'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Add'" (onConfirm)="confirmAddSSID()"
								[disabled]="!ssidAddingForm.valid">
							</confirm-popover>
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
								[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'" [popoverCancelText]="'No'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Cancel'" (onConfirm)="cancelEditSSID()">
							</confirm-popover>
						</div>
					</mat-header-cell>
				</ng-container>

				<ng-container matColumnDef="ADD_STUDENT_IDENTIFIER_TYPES.TYPE">
					<mat-header-cell *matHeaderCellDef>
						<div class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									ID Type
								</mat-label>
								<mat-select formControlName="idType" [disabled]="true">
									<mat-option *ngFor="let studentIdentifierType of studentIdentifierTypes"
										[value]="studentIdentifierType" [disabled]="true">
										{{studentIdentifierType.TYPE}}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</mat-header-cell>
				</ng-container>

				<ng-container matColumnDef="ADD_IDENTIFIER_VALUE">
					<mat-header-cell *matHeaderCellDef>
						<div class="row">
							<input-ssid [form]="ssidAddingForm" [controlName]="'identifierValue'"
								[studentId]="studentId"></input-ssid>
						</div>
					</mat-header-cell>
				</ng-container>
			</form>

			<mat-header-row *matHeaderRowDef="childIdDisplayedColumns"></mat-header-row>
			<mat-row *matHeaderRowDef="newChildIdDisplayedColumns" [hidden]="ssidFound || !editing"></mat-row>
			<mat-row *matRowDef="let row; columns: childIdDisplayedColumns;"></mat-row>
		</mat-table>

	</div>
</div>

<div class="margin-bottom-lg padding-top-md">
	<mat-card-title class="h5">
		Local IDs (optional)
	</mat-card-title>
	<mat-divider> </mat-divider>

	<div class="margin-top-md">
		<mat-table [dataSource]="localTableDataSource" class="table-responsive mat-elevation-z1" matSort>
			<form [formGroup]="localIdEditingForm">
				<ng-container matColumnDef="EDIT">
					<mat-header-cell *matHeaderCellDef> </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div>
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'delete'" [color]="'warn'"
								[popoverMsg]="'Delete Confirmation'" [popoverConfirmText]="'Delete'"
								[popoverConfirmColor]="'warn'" [tooltip]="'Delete'" (onConfirm)="deleteLocal(element)">
							</confirm-popover>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="STUDENT_IDENTIFIER_ORGANIZATIONS[0].ORGANIZATION.NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> School District </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div *ngIf="element.STUDENT_IDENTIFIER_ORGANIZATIONS.length > 0">
							{{element.STUDENT_IDENTIFIER_ORGANIZATIONS[0].ORGANIZATION.NAME}}
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="IDENTIFIER_VALUE">
					<mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div>
							{{element.IDENTIFIER_VALUE}}
						</div>
					</mat-cell>
				</ng-container>
			</form>

			<ng-container matColumnDef="ADD" disabled>
				<mat-header-cell *matHeaderCellDef>
					<div *ngIf="!addingLocal">
						<button mat-raised-button color="primary" (click)="addLocal()">New Local ID</button>
					</div>
				</mat-header-cell>
			</ng-container>

			<form [formGroup]="localIdEditingForm">
				<ng-container matColumnDef="ADD_EDIT" disabled>
					<mat-header-cell *matHeaderCellDef>
						<div *ngIf="addingLocal">
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'add'" [color]="'primary'"
								[popoverMsg]="'Add new Local ID'" [popoverConfirmText]="'Add'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Add'" (onConfirm)="confirmAddLocal()"
								[disabled]="!localIdEditingForm.valid || (localSchoolDistrict ? !localSchoolDistrict.ID : true)">
							</confirm-popover>
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
								[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'" [popoverCancelText]="'No'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Cancel'" (onConfirm)="cancelEditLocal()">
							</confirm-popover>
						</div>
					</mat-header-cell>
				</ng-container>

				<ng-container matColumnDef="ADD_SCHOOL_DISTRICT">
					<mat-header-cell *matHeaderCellDef>
						<div class="row">
							<district-dropdown (eventEmitterSchoolDistrict)="districtsSelected($event)"
								[autoRefreshOnRegionChange]="true" [isMultiple]="false"></district-dropdown>
						</div>
					</mat-header-cell>
				</ng-container>

				<ng-container matColumnDef="ADD_IDENTIFIER_VALUE">
					<mat-header-cell *matHeaderCellDef>
						<div class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									Identifier Value
								</mat-label>
								<input matInput type="string" formControlName="identifierValue" />
							</mat-form-field>
						</div>
					</mat-header-cell>
				</ng-container>
			</form>

			<mat-header-row *matHeaderRowDef="localDisplayedColumns"></mat-header-row>
			<mat-row *matHeaderRowDef="newLocalDisplayedColumns" [hidden]="!editing"></mat-row>
			<mat-row *matRowDef="let row; columns: localDisplayedColumns;"></mat-row>
		</mat-table>

	</div>
</div>

<div class="margin-bottom-lg padding-top-md">
	<mat-card-title class="h5">
		COEstar (Legacy)
	</mat-card-title>
	<mat-divider> </mat-divider>

	<div class="margin-top-md">
		<mat-table [dataSource]="coeStarTableDataSource" class="table-responsive mat-elevation-z1" matSort>

			<ng-container matColumnDef="STUDENT_IDENTIFIER_ORGANIZATIONS[0].ORGANIZATION.REGIONS[0].CODE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Region </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div *ngIf="element.STUDENT_IDENTIFIER_ORGANIZATIONS.length > 0">
						{{element.STUDENT_IDENTIFIER_ORGANIZATIONS[0].ORGANIZATION.REGIONS[0].CODE}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="IDENTIFIER_VALUE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.IDENTIFIER_VALUE}}
					</div>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="coeStarDisplayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: coeStarDisplayedColumns;"></mat-row>
		</mat-table>

	</div>
</div>